import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class RejectOrganisationIdentNumChange extends Relay.Mutation {
    static propTypes = { organisationId: PropTypes.string.isRequired };

    getMutation() { return Relay.QL`mutation { rejectOrganisationIdentNumChange }`; }

    getVariables() { return { organisationId: this.props.organisationId }; }

    getFatQuery() {
        return Relay.QL`
            fragment on RejectOrganisationIdentNumChangePayload { ok }
        `;
    }

    getConfigs() { return [{ type: 'REQUIRED_CHILDREN', children: [this.getFatQuery()] }]; }
}


